import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'
import { IYahooResponse } from '@/features/yahoo-responses/yahooResponsesSlice';

export const getResponses = async (params?: any): Promise<IApiResponse<IList<IYahooResponse>>> => {
	const { data } = await axios.get<IApiResponse<IList<IYahooResponse>>>('/api/yahoo-response', { params })
	return data
}